import type React from 'react';

import { observer } from 'mobx-react';

import { useAlternates } from 'bz-core-controls/controls/general/nested-list-new/stores/menu-store';

import { useAction } from 'bz-utilities/hooks/action';
import useComputed from 'bz-utilities/hooks/computed';

import Alternate from './controls/alternate';

export interface IProps {
  values: Map<string, any>;
}

const Alternates: React.FC<IProps> = observer(({ values }) => {
  const alternates = useAlternates();

  const entries: [string, any][] = useComputed(() => {
    return Array.from(alternates.entries());
  }, [alternates]);

  const onChange = useAction(
    (key: string, value: any): void => {
      values.set(key, value);
    },
    [values]
  );

  const onRemove = useAction(
    (key: string): void => {
      values.delete(key);
    },
    [values]
  );

  const content = entries.map(([key, value]) => {
    return (
      <Alternate
        key={key}
        src={key}
        title={key}
        list={value}
        value={values.get(key)}
        onRemove={onRemove}
        onChange={onChange}
      />
    );
  });

  return <>{content}</>;
});

Alternates.displayName = 'Alternates';

export default Alternates;
